/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import StatusIndicators from './StatusIndicators';
import DisplayName from './DisplayName';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
  isDisplayNameVisible,
  isNameReadOnly
} from 'store/modules/base/config';
import { isScreenShareParticipantById } from 'store/modules/base/participants';

const useStyles = makeStyles(() => {
  return {
    nameContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      overflow: 'hidden',

      '&>div': {
        display: 'flex',
        overflow: 'hidden'
      }
    }
  };
});

const ThumbnailBottomIndicators = ({
  className,
  local,
  participantId,
  showStatusIndicators = true,
  thumbnailType
}) => {
  const styles = useStyles();
  const _allowEditing = !useSelector(isNameReadOnly);
  const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
  const _showDisplayName = useSelector(isDisplayNameVisible);
  const isVirtualScreenshareParticipant = useSelector((state) =>
    isScreenShareParticipantById(state, participantId)
  );

  return (
    <div className={className}>
      {_showDisplayName && (
        <span className={styles.nameContainer}>
          <DisplayName
            allowEditing={local ? _allowEditing : false}
            displayNameSuffix={local ? _defaultLocalDisplayName : ''}
            elementID={
              local ? 'localDisplayName' : `participant_${participantId}_name`
            }
            participantID={participantId}
            thumbnailType={thumbnailType}
          />
        </span>
      )}
      {showStatusIndicators && (
        <StatusIndicators
          audio={!isVirtualScreenshareParticipant}
          moderator={true}
          participantID={participantId}
          screenshare={isVirtualScreenshareParticipant}
          thumbnailType={thumbnailType}
        />
      )}
    </div>
  );
};

export default React.memo(withBoundary(ThumbnailBottomIndicators));

ThumbnailBottomIndicators.propTypes = {
  /**
   * Class name for indicators container.
   */
  className: PropTypes.string,

  /**
   * Whether or not the indicators are for the local participant.
   */
  local: PropTypes.bool,

  /**
   * Id of the participant for which the component is displayed.
   */
  participantId: PropTypes.string,

  /**
   * Whether or not to show the status indicators.
   */
  showStatusIndicators: PropTypes.bool,

  /**
   * The type of thumbnail.
   */
  thumbnailType: PropTypes.string
};
